import { useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

/**
 * Emits New Relic page actions for SPA route transitions (pathname only).
 */
export default function RouteTransitionTracker() {
  const location = useLocation();
  const previousPath = useRef<string | null>(null);
  const startedAt = useRef(performance.now());

  useEffect(() => {
    const path = location.pathname;
    const duration_ms = Math.round(performance.now() - startedAt.current);
    const from = previousPath.current;
    previousPath.current = path;
    startedAt.current = performance.now();

    if (!from || from === path) return;

    const nreum = (window as unknown as {
      NREUM?: { addPageAction?: (name: string, attrs: Record<string, unknown>) => void };
    }).NREUM;
    nreum?.addPageAction?.("RouteTransition", {
      from,
      to: path,
      duration_ms,
    });
  }, [location.pathname]);

  return null;
}
